export default "__VITE_ASSET__C3FRMH9s__"